import React from 'react';
import PropTypes from 'prop-types';

import { getModifiers } from '@/shared/ui/core';
import { LinkStyled, AStyled } from './Link.styled';

const modifierProps = ['alertTag', 'inverted', 'primary', 'secondary'];

const Link = ({ content, children, ...props }) => {
  const { href } = props;
  const Component = href ? AStyled : LinkStyled;
  const { primary, ...validProps } = props;

  return (
    <Component modifiers={getModifiers(props, modifierProps)} {...validProps}>
      {content ?? children}
    </Component>
  );
};

Link.propTypes = {
  content: PropTypes.string,
  to: PropTypes.string,
};
Link.defaultProps = {
  content: '',
  to: '',
};

export default Link;
